import {
  createSlice,
  createAsyncThunk,
  createSelector,
} from '@reduxjs/toolkit';

import { currentUser, isAuthGuardActive } from 'constants/defaultValues';
import { getCurrentUser } from 'helpers/Utils';
import authApi from 'api/auth';

const initialState = {
  currentUser: isAuthGuardActive ? currentUser : getCurrentUser(),
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const isPending = (action) => {
  return (
    typeof action.type === 'string' &&
    action.type.startsWith('auth/') &&
    action.type.endsWith('/pending')
  );
};

const isRejected = (action) => {
  return (
    typeof action.type === 'string' &&
    action.type.startsWith('auth/') &&
    action.type.endsWith('/rejected')
  );
};

export const login = createAsyncThunk(
  'auth/login',
  async ({ email, password }, thunkAPI) => {
    const response = await authApi.login(email, password);
    if (response.statusText === 'OK') {
      // await authStorage.storeUserAndToken(response.data);
      return response.data;
    } else {
      // const readbleError = toReadableError(response.data.errors);
      const readbleError = response.data.errors;
      return thunkAPI.rejectWithValue(readbleError);
    }
  }
);

export const register = createAsyncThunk(
  'auth/register',
  async ({ name, email, phone, password, optId }, thunkAPI) => {
    // const response = await authApi.register(
    //   name,
    //   email,
    //   phone,
    //   password,
    //   optId
    // );
    // if (response.ok) {
    //   await authStorage.storeUserAndToken(response.data);
    //   return response.data;
    // } else {
    //   // const readbleError = toReadableError(response.data.errors);
    //   const readbleError = response.data.errors;
    //   return thunkAPI.rejectWithValue(readbleError);
    // }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearAuthState(state) {
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const { user } = action.payload;
        state.user = user;
      })
      .addCase(register.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const { user } = action.payload;
        state.user = user;
      });

    builder.addMatcher(isPending, (state) => {
      state.status = 'loading';
      state.error = null;
    });
    builder.addMatcher(isRejected, (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    });
  },
});

export default authSlice.reducer;

// export const currentUserSelector = (state) => state.auth.user;

export const { clearAuthState } = authSlice.actions;
